import * as React from 'react';
import classNames from 'classnames';
import {RichIcon, Text, NOOP, Flex} from 'components/UIKit';
import {LoginMethod} from '../../types';
import style from './login-button.scss';
import * as icons from './images';

interface LoginButtonProps {
  method: LoginMethod;
  onClick?: (method: LoginMethod) => void;
}

export class LoginButton extends React.PureComponent<LoginButtonProps> {
  handleClick = () => {
    const {onClick = NOOP, method} = this.props;

    onClick(method);
  };

  render() {
    const {method} = this.props;
    const methodIcon = icons[method.name.toLowerCase()];
    const methodClassname = style[method.name.toLowerCase()];
    return (
      <Flex
        wrapperComponent="button"
        alignItems="center"
        className={classNames(style.LoginButton, methodClassname)}
        onClick={this.handleClick}
      >
        <Flex alignItems="center" justifyContent="center" className={style.IconWrap}>
          <RichIcon alt={method.cta} size={22} source={methodIcon} />
        </Flex>
        <Text className={style.Text} inheritColor resetMargin text={method.cta} />
      </Flex>
    );
  }
}
